<div class="bg-blue-900 flex items-center justify-between p-4 shadow-md">
  <!-- Left: Image and Info -->
  <div class="flex items-center text-white">
    <button (click)="openSidenav()" mat-icon-button type="button">
      <mat-icon svgIcon="mat:menu"></mat-icon>
    </button>
    <div class="flex flex-col">
      <span class="text-lg font-semibold"> {{ this.userdata?.name }}</span>
      <span class="text-sm">{{ this.userdata?.mobile }}</span>
    </div>
  </div>

  <!-- Right: Logout Icon -->
  <button (click)="logout()" class="text-orange-300 hover:text-orange-800 transition">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-9 w-12" fill="none" viewBox="0 0 16 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m0-10V5m-1 1h-2a2 2 0 00-2 2v8a2 2 0 002 2h2" />
    </svg>
  </button>
</div>
<div class="bg-blue-700 text-white text-center">
  <h1 class="text-lg font-bold" (click)="companyselect()">{{ companylist?.cname }}</h1>
</div>
<!-- <div class="bg-blue-700 text-white text-center">
  <img src="assets/img/images/ssslogo.png" alt="Logo" class="h-24 w-24 rounded-full object-cover mr-4" />
  <h1 class="text-lg font-bold">{{ companylist?.cname }}</h1>
</div> -->
<div class="bg-blue-700 text-white p-4 relative">
  <div class="flex justify-between items-start">
    <!-- Left Section: Logo with Company Name Below -->
    <div class="flex flex-col items-center">
      <img src="assets/img/images/ssslogo.png" alt="Logo" class="h-24 w-24 rounded-full object-cover" />
      <h1 class="text-sm font-bold mt-2 text-center">
        <!-- {{ companylist?.cname }} -->
      </h1>
    </div>

    <!-- Right Section -->
    <div class="flex flex-col items-end space-y-2">
      <!-- Select Company Button (No Wrap) -->
      <!-- <button class="bg-white text-blue-700 px-4 py-1 rounded shadow whitespace-nowrap">Select Company</button> -->

      <!-- Year Dropdown -->
      <!-- <span class="text-center mr-6">2025-2026</span> -->
    </div>
  </div>
  <!-- Overflow Image (bottom overlap effect) -->
  <img src="assets/img/profile/user-1.jpg" alt="Decoration" class="absolute right-4 -bottom-4 h-24 w-24 object-cover bg-white rounded-full mr-3" />
</div>
<!-- <div> -->
<router-outlet></router-outlet>
<!-- </div> -->
